<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <div class="md-layout md-size-100">
                <div class="md-layout-item md-size-100">
                    <div class="md-layout-item md-size-100">
                        <div class="md-gutter md-alignment-top-right">
                            <date-range-picker
                                    v-model="calendarPeriod"
                                    :startDate="calendarPeriod.startDate"
                                    :endDate="calendarPeriod.endDate"
                                    :locale-data="calendarLocale"
                                    :ranges="ranges"
                                    opens="right">
                                <md-input v-model="calendarPeriod" slot-scope="picker">Days Interval</md-input>
                            </date-range-picker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="md-layout-item md-size-100">
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-green">
                            <div class="card-icon">
                                <md-icon>assignment</md-icon>
                            </div>
                            <h4 class="title">Failed Orders</h4>
                        </md-card-header>
                        <md-card-content>
                            <md-table
                                    :value="queuedOrders"
                                    :md-sort.sync="queuedOrdersCurrentSort"
                                    :md-sort-order.sync="queuedOrdersCurrentSortOrder"
                                    :md-sort-fn="queuedCustomSort"
                                    class="paginated-table table-striped table-hover"
                            >
                                <md-table-row slot="md-table-row" slot-scope="{ item }">
                                    <md-table-cell md-label="ID">{{item.id}}</md-table-cell>
                                    <md-table-cell md-label="Order Time">{{ item.order_time | moment }}</md-table-cell>
                                    <md-table-cell md-label="Merchant Name">{{item.merchant_name}}</md-table-cell>
                                    <md-table-cell md-label="Address">{{ item.merchant_address }}</md-table-cell>
                                    <md-table-cell md-label="Name">{{ item.order_name }}</md-table-cell>
                                    <md-table-cell md-label="Email">{{ item.user_email }}</md-table-cell>
                                    <md-table-cell md-label="Platform">{{ item.platform }}</md-table-cell>
                                    <md-table-cell md-label="Total">&#36;{{ item.total_price }}</md-table-cell>
                                    <md-table-cell md-label="Failure Message">{{ item.payment_message }}</md-table-cell>
                                    <md-table-cell md-label="Delete">
                                        <md-button class="md-just-icon md-danger md-simple" @click.native="showDeleteConfirm(item, true)">
                                            <md-icon>delete</md-icon>
                                        </md-button>
                                    </md-table-cell>
                                    <md-table-cell />
                                </md-table-row>
                            </md-table>
                        </md-card-content>
                        <md-card-actions md-alignment="space-between">
                            <div class="">
                                <p class="card-category">
                                    Showing {{ queued_orders_from + 1 }} to {{ queued_orders_to }} of {{ queued_total }} entries
                                </p>
                            </div>
                            <pagination
                                    class="pagination-no-border pagination-success"
                                    v-model="queuedOrdersHandleProps.currentPage"
                                    :per-page="queuedOrdersHandleProps.perPage"
                                    :total="queued_total"
                            >
                            </pagination>
                        </md-card-actions>
                    </md-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"
import { StatsCard, AnimatedNumber } from "@/components";
import { Pagination } from "@/components";
import { showConfirmationDialog } from '@/components/ActionConfirm';
import DateRangePicker from 'vue2-daterange-picker';
import JsonCSV from 'vue-json-csv'
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'

export default {
    name: "OrderList",
    components: {
        StatsCard,
        AnimatedNumber,
        Pagination,
        DateRangePicker,
        'downloadCsv': JsonCSV
    },
    computed: {
        queued_orders_to() {
            let highBound = this.queued_orders_from + this.queuedOrdersHandleProps.perPage;
            if (this.queued_total < highBound) {
                highBound = this.queued_total;
            }
            return highBound;
        },
        queued_orders_from() {
            return this.queuedOrdersHandleProps.perPage * (this.queuedOrdersHandleProps.currentPage - 1);
        },
        queued_total() {
            return this.queued_pagination.total;
        },
    },
    data() {
        return {
            queuedOrders: { },
            queuedOrdersCurrentSort: "names",
            queuedOrdersCurrentSortOrder: "asc",
            queued_pagination: {
                total: 0
            },
            propsToSearch: ["name"],
            queuedOrdersHandleProps: {
                searchQuery: "",
                currentPage: 1,
                perPage: 25
            },
            calendarPeriod: {
                startDate: moment().startOf('day'),
                endDate: moment().endOf('day')
            },
            dateStart: moment().startOf('day'),
            dateEnd: moment().endOf('day'),
            calendarLocale: {
                direction: 'ltr',
                format: 'MM/DD/YYYY',
                separator: ' - ',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: moment.weekdaysMin(),
                monthNames: moment.monthsShort(),
                firstDay: 0,
                showWeekNumbers: true
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                'This month': [moment().startOf('month'), moment().endOf('month')],
                'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'This year': [moment().startOf('year'), moment().endOf('year')]
            },
            formatter: new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            })
        }
    },
    created() {
        this.getFailedOrders()
    },
    methods: {
        queuedCustomSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.queuedOrdersCurrentSort;
                if (this.queuedOrdersCurrentSortOrder === "desc") {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
        getFailedOrders() {
            this.$http.secured.get(`/v1/orders/failed`+
                `?page=${this.queuedOrdersHandleProps.currentPage}`+
                `&page_count=${this.queuedOrdersHandleProps.perPage}`+
                `&end_date=${this.dateEnd}&start_date=${this.dateStart}`)
                .then(this.queuedSetData)
                .catch(error => alert(error))
        },
        queuedSetData(response) {
            this.queuedOrders = response.data.orders;
            this.queued_pagination.total = response.data.meta.total
        },
        showDeleteConfirm(order) {
            showConfirmationDialog(() => this.deleteOrder(order))
        },
        deleteOrder: function (order) {
            this.$http.secured.delete(`/v1/orders/${order.id}`)
                .then(() => {
                    this.queuedOrders.splice(this.queuedOrders.indexOf(order), 1)
                })
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MM/DD/YY hh:mm A');
        }
    },
    watch: {
        queuedOrdersHandleProps: {
            handler() {
                this.getFailedOrders()
            },
            deep: true
        },
        calendarPeriod: {
            handler() {
                this.dateStart = moment(this.calendarPeriod.startDate).startOf('day')
                this.dateEnd = moment(this.calendarPeriod.endDate).endOf('day')
                this.getFailedOrders()
            },
            deep: true
        }
    }
}
</script>
